import { themeConWeb } from '@app/util/modernThemeConweb'
import { format, parse, subDays } from 'date-fns'
import { isEmpty, set } from 'lodash'
import React, { Component, useState } from 'react'
import { connect } from 'react-redux'

import { Avatar, Box, Divider, Typography, Tooltip, Button } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import { makeStyles } from '@material-ui/core/styles'
import currency from 'currency.js'
import DialogDeliveryInstructions from '../components/checkout/DialogDeliveryInstructions'
import { ArticleLarge, SpinnerCard } from '../components/common/Layout'
import { LocationLogo } from '../components/common/Location'
import { OrderConfirmationDetails, OrderSummary } from '../components/common/OrderSummary'
import AutoFavoriteModal from '../components/confirmation/AutoFavorite'
import ContactUsSidebar from '../components/contact-us/ContactUsSidebar'
import { closeAutoFavorite } from '../redux/modules/checkout'
import { loadDeliveryDropoffStart } from '../redux/modules/delivery'
import { loadFavoriteStart } from '../redux/modules/favorite'
import {
  toggleDeliveryInstructionsDialog,
  updateUserSavedLocationStart,
} from '../redux/modules/location'
import { loadMenuStart } from '../redux/modules/menu'
import { loadOrderByIdStart, loadOrderStart } from '../redux/modules/orderDetail'
import {
  selectCurrentLocationWithAddress,
  selectCurrentSavedLocation,
} from '../redux/modules/selectors'
import { loadReasonsByOrder, submitTicket } from '../redux/modules/ticket'
import LinkButton from '../components/common/LinkButton'
import { loadOfficesStart } from '../redux/modules/offices'
import { selectOfficeAccounts } from '../redux/selectors/accountSelectors'
import { getFriendsOrdersStart } from '../redux/modules/friends'
import {
  formatCentsToPrettyDollars,
  formatDollarsToCents,
} from '../components/teams/perks/giftCardUtils'
import { CreditsEarnedNotice } from '../util/reserveUtils'
import { HeaderInnerPage } from '../layouts/LayoutInnerPage'
import { formatUrl } from '../util/formatUtils'
import { locationRoute } from '../routes/routes'
import { orderStateText } from '../components/home/utils/orderUtils'
import { convertTo12HourFormat } from '../redux/selectors/utils/time'

class PageConfirmation extends Component {
  constructor(props) {
    super(props)
    const {
      loadOrderByIdStart,
      loadReasonsByOrder,
      match: {
        params: { orderId },
      },
    } = this.props
    loadOrderByIdStart(orderId)
    loadReasonsByOrder(orderId)
    const timer = setInterval(() => loadOrderByIdStart(orderId), 600000)
    this.state = {
      showOrderSummary: false,
      timer,
    }
  }

  componentDidMount() {
    let {
      selectedDate,
      loadOrderStart,
      match: {
        params: { locationId },
      },
      loadOfficesStart,
      getFriendsOrdersStart,
      offices,
      order,
    } = this.props
    loadOrderStart(format(selectedDate, 'YYYYMMDD'), locationId)
    loadOfficesStart(locationId)
    if (offices && offices.length > 0 && order) {
      getFriendsOrdersStart(offices[0].id, format(subDays(order.deliveryDate, 0), 'YYYY-MM-DD'))
    }
    window && window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps) {
    let {
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadMenuStart,
      loadOrderStart,
      loadOfficesStart,
      getFriendsOrdersStart,
      match: {
        params: { locationId },
      },
      order,
      offices,
      selectedDate,
    } = this.props
    if ((!prevProps.order && order) || (order && order.orderId !== prevProps.order.orderId)) {
      loadOrderStart(format(order.orderDate, 'YYYYMMDD'), locationId)
      loadMenuStart(order.deliveryDropoffId)
      loadDeliveryDropoffStart(order.deliveryDropoffId)
      loadFavoriteStart(order.menuId)
      loadOfficesStart(locationId)
    }

    if (
      offices &&
      (selectedDate !== prevProps.selectedDate || offices !== prevProps.offices) &&
      offices.length > 0 &&
      order
    ) {
      getFriendsOrdersStart(offices[0].id, format(subDays(order.deliveryDate, 0), 'YYYY-MM-DD'))
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  toggleShowOrderSummary = () => {
    this.setState({ showOrderSummary: !this.state.showOrderSummary })
  }

  render() {
    const {
      autoFavorite,
      closeAutoFavorite,
      curSavedLocation,
      favoriteInfo,
      history,
      deliveryDropoff,
      isCheckingStatus,
      isLoadingFavorites,
      isUpdatingSavedLocation,
      isWebpSupported,
      loading,
      match: {
        params: { locationId },
      },
      order,
      orders,
      profile,
      reasons,
      showDeliveryInstructionsDialog,
      submitTicket,
      submitting,
      toggleDeliveryInstructionsDialog,
      updateSavedLocationError,
      updateUserSavedLocationStart,
      updatingModal,
      location,
      friendsOrdered,
      avatarId,
      firstName,
      lastName,
      isLoadingFriendsOrders,
    } = this.props

    let autoFavorites = []
    order &&
      favoriteInfo &&
      favoriteInfo.forEach(info => {
        autoFavorites = autoFavorites.concat(
          order.orderItems.filter(item => item.menuItemId === info.menuItemId),
        )
      })
    return (
      <>
        <ConfirmationComponent
          location={location}
          friendsOrdered={friendsOrdered}
          avatarId={avatarId}
          firstName={firstName}
          lastName={lastName}
          autoFavorite={autoFavorite}
          autoFavorites={autoFavorites}
          closeAutoFavorite={closeAutoFavorite}
          history={history}
          isCheckingStatus={isCheckingStatus}
          isLoadingFriendsOrders={isLoadingFriendsOrders}
          isLoadingFavorites={isLoadingFavorites}
          isWebpSupported={isWebpSupported}
          loading={loading}
          locationId={locationId}
          order={order}
          orders={orders}
          profile={profile}
          reasons={reasons}
          showOrderSummary={this.state.showOrderSummary}
          submitTicket={submitTicket}
          submitting={submitting}
          toggleShowOrderSummary={this.toggleShowOrderSummary}
          updatingModal={updatingModal}
          deliveryDropoff={deliveryDropoff}
        />
        <DialogDeliveryInstructions
          curSavedLocation={curSavedLocation}
          isUpdatingSavedLocation={isUpdatingSavedLocation}
          showDeliveryInstructionsDialog={showDeliveryInstructionsDialog}
          showOnEmptyDeliveryInstructions
          toggleDeliveryInstructionsDialog={toggleDeliveryInstructionsDialog}
          updateSavedLocationError={updateSavedLocationError}
          updateUserSavedLocationStart={updateUserSavedLocationStart}
        />
      </>
    )
  }
}

export const ConfirmationComponent = ({
  location,
  friendsOrdered,
  avatarId,
  firstName,
  lastName,
  deliveryDropoff,
  isLoadingFriendsOrders,
  autoFavorites,
  closeAutoFavorite,
  isLoadingFavorites,
  loading,
  locationId,
  order,
  reasons,
  showOrderSummary,
  submitTicket,
  submitting,
  toggleShowOrderSummary,
}) => {
  const showReclaimDeliveryFeeCard =
    deliveryDropoff &&
    order &&
    deliveryDropoff.type === 'Reserve' &&
    order.deliveryIsSplit &&
    order.deliveryFeeContribution > 0

  const showCoworkersAndCredits = order && !order.statusText.includes(orderStateText.CANCELED)

  return (
    <ArticleLarge>
      <HeaderInnerPage
        showBackButton
        backButtonRoute={formatUrl(locationRoute.path, { locationId })}
      >
        Home
      </HeaderInnerPage>
      <OrderSummaryCard
        order={order}
        loading={loading}
        isLoadingFavorites={isLoadingFavorites}
        submitting={submitting}
        showOrderSummary={showOrderSummary}
        toggleShowOrderSummary={toggleShowOrderSummary}
        deliveryDropoff={deliveryDropoff}
        location={location}
        autoFavorites={autoFavorites}
      />
      {showReclaimDeliveryFeeCard && <ReclaimDeliveryFeeCard order={order} loading={loading} />}
      <div className="row" style={{ margin: '0 -8px' }}>
        {showCoworkersAndCredits && (
          <div className="col-xs-12 col-md-6">
            <CoworkersAndCreditsCard
              order={order}
              friendsOrdered={friendsOrdered}
              deliveryDropoff={deliveryDropoff}
              isLoadingFriendsOrders={isLoadingFriendsOrders}
              loading={loading}
              isLoadingFavorites={isLoadingFavorites}
              submitting={submitting}
              avatarId={avatarId}
              firstName={firstName}
              lastName={lastName}
            />
          </div>
        )}
        <aside
          className={`col-xs-12 ${showCoworkersAndCredits && 'col-md-6'} confirmation-contact-us`}
        >
          <ContactUsSidebar
            className="contact-us-form"
            locationId={locationId}
            order={order}
            orderHistorySize
            reasons={reasons}
            showForm
            submitticket={submitTicket}
          />
        </aside>
      </div>
    </ArticleLarge>
  )
}

const OrderSummaryCard = ({
  order,
  loading,
  isLoadingFavorites,
  submitting,
  showOrderSummary,
  toggleShowOrderSummary,
  deliveryDropoff,
  location,
  autoFavorites,
}) => {
  if (!order) {
    return <></>
  }
  return (
    <SpinnerCard spinnerActive={!order || loading || isLoadingFavorites || submitting}>
      <Box display={'flex'} flexDirection={'row'} marginBottom={'2em'}>
        <Box marginRight={'2em'} style={{ width: 75, height: 75 }}>
          <LocationLogo
            logoAlt={order.storeName + ' Logo'}
            logoLink={order.logoUrl}
            logoOptions="?height=100&width=100&fit=contain&background=white"
          />
        </Box>
        <DateAndRestaurant
          dateTime={order.originalDeliveryDateTime}
          restaurant={order.storeName}
          orderId={order.orderId}
        />
        <div style={{ flexGrow: 1 }} />
        <OrderStatusAndTimeText orderStatus={order.statusText} order={order} />
      </Box>
      <Box marginBottom={'2em'}>
        <Divider />
      </Box>
      <PickupInstructions instructions={order.pickupInstructions} />
      <Box marginTop={'1em'} display={'flex'}>
        <div style={{ flexGrow: 1 }} />
        <LinkButton
          onClick={toggleShowOrderSummary}
          color={themeConWeb.color.brandPrimary}
          style={{
            fontSize: themeConWeb.fontSizes.basePlus1,
            fontWeight: 700,
            textDecoration: 'underline',
            textTransform: 'none',
          }}
        >
          {showOrderSummary ? 'Hide' : 'Show'} Order Details
        </LinkButton>
      </Box>
      {showOrderSummary && (
        <OrderSummary>
          {deliveryDropoff && (
            <OrderConfirmationDetails
              order={order}
              location={location}
              deliveryType={deliveryDropoff.type}
            />
          )}
        </OrderSummary>
      )}
      {autoFavorites.length >= 1 && (
        <AutoFavoriteModal closeAutoFavorite={closeAutoFavorite} items={autoFavorites} />
      )}
    </SpinnerCard>
  )
}

const DateAndRestaurant = ({ dateTime, restaurant, orderId }) => {
  const formattedDate = format(parse(dateTime), 'dddd, MMMM D, YYYY')

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Typography style={{ marginBottom: '5px' }}>Order Confirmation #{orderId}</Typography>
      <Typography
        variant="h3"
        style={{ fontSize: themeConWeb.fontSizes.basePlus3, fontWeight: 500 }}
      >
        {restaurant}
      </Typography>
      <Typography
        variant="overline"
        style={{ textTransform: 'uppercase', color: themeConWeb.color.greyShade3 }}
      >
        {formattedDate}
      </Typography>
    </Box>
  )
}

const OrderStatusAndTimeText = ({ orderStatus, order }) => {
  if (
    orderStatus.includes(orderStateText.CREATED) ||
    orderStatus.includes(orderStateText.ON_TIME)
  ) {
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <Typography
          variant="h3"
          style={{ fontSize: themeConWeb.fontSizes.basePlus2, fontWeight: 700 }}
        >
          Est. Delivery
        </Typography>
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus2 }}>
          at {order.expectedDeliveryTimeDisplay}
        </Typography>
      </Box>
    )
  }

  if (orderStatus.includes(orderStateText.DELIVERED)) {
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <Typography
          variant="h3"
          style={{ fontSize: themeConWeb.fontSizes.basePlus2, fontWeight: 700 }}
        >
          Delivered
        </Typography>
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus2 }}>
          at {convertTo12HourFormat(order.deliveryTime.split('.')[0])}
        </Typography>
      </Box>
    )
  }

  if (orderStatus.includes(orderStateText.CANCELED)) {
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <Typography
          variant="h3"
          style={{
            fontSize: themeConWeb.fontSizes.basePlus2,
            fontWeight: 700,
            color: themeConWeb.color.dangerLight,
          }}
        >
          Canceled
        </Typography>
      </Box>
    )
  }

  if (orderStatus.includes(orderStateText.LATE)) {
    return (
      <Box display={'flex'} flexDirection={'column'}>
        <Typography
          variant="h3"
          style={{
            fontSize: themeConWeb.fontSizes.basePlus2,
            fontWeight: 700,
          }}
        >
          Late
        </Typography>
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus2 }}>
          Now at {order.expectedDeliveryTimeDisplay}
        </Typography>
      </Box>
    )
  }
}

const PickupInstructions = ({ instructions }) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus1, fontWeight: 700 }}>
        Where will my food be delivered?
      </Typography>
      <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus1 }}>{instructions}</Typography>
    </Box>
  )
}

const ReclaimDeliveryFeeCard = ({ order, loading }) => {
  const [copied, setCopied] = useState(false)

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(
        `${process.env.REACT_APP_FOODSBY_BASE_URL}/${order.locationId}/deliveries/${order.deliveryDropoffId}/order`,
      )
      .then(() => {
        setCopied(true)
      })
  }

  return (
    <SpinnerCard spinnerActive={!order || loading} style={{ border: '3px solid #6E8D28' }}>
      {order && (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus4 }}>
            Reclaim your{' '}
            <span style={{ fontWeight: 700 }}>
              {currency(order.deliveryFeeContribution, { formatWithSymbol: true }).format()}{' '}
              delivery fee
            </span>{' '}
            when others order!
          </Typography>
          <Box marginBottom={'1.5em'}>
            <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus1 }}>
              Share this link with others in your office or building to earn more credits with each
              order!
            </Typography>
          </Box>
          <Box
            style={{
              border: '2px solid black',
              padding: '15px',
              borderRadius: '3px',
              width: '70%',
              textAlign: 'center',
            }}
          >
            <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus1 }}>
              {`${process.env.REACT_APP_FOODSBY_BASE_URL}/${order.locationId}/deliveries/${order.deliveryDropoffId}/order`}
            </Typography>
          </Box>
          <Box marginTop={'1em'} marginBottom={'-1em'}>
            <Button variant="text" color="primary" onClick={handleCopyLink}>
              Copy Link
            </Button>
          </Box>
          {copied && (
            <Typography style={{ marginTop: '25px', color: 'green', marginBottom: '-1em' }}>
              Link copied!
            </Typography>
          )}
        </Box>
      )}
    </SpinnerCard>
  )
}

const CoworkersAndCreditsCard = ({
  order,
  friendsOrdered,
  deliveryDropoff,
  isLoadingFriendsOrders,
  loading,
  isLoadingFavorites,
  submitting,
  avatarId,
  firstName,
  lastName,
}) => {
  const creditsEarnedInCents =
    formatDollarsToCents(order?.deliveryFeeContribution) -
    formatDollarsToCents(order?.deliveryFeePerPerson)
  const showCreditsEarnedSection =
    order && deliveryDropoff && deliveryDropoff.type === 'Reserve' && order.deliveryIsSplit

  return (
    <SpinnerCard
      spinnerActive={
        !order ||
        !friendsOrdered ||
        !deliveryDropoff ||
        isLoadingFriendsOrders ||
        loading ||
        isLoadingFavorites ||
        submitting
      }
      style={{ height: '29.5em' }}
    >
      <Box display={'flex'} flexDirection={'column'} height={'25.4em'} maxHeight={'25.4em'}>
        {showCreditsEarnedSection && (
          <CreditsEarned
            creditsEarnedInCents={creditsEarnedInCents}
            deliveryFeePerPerson={order.deliveryFeePerPerson}
            deliveryFeeContribution={order.deliveryFeeContribution}
          />
        )}
        {order && friendsOrdered && (
          <CustomersOrdered
            friendsOrders={
              friendsOrdered.find(f => f.dropoffId === order.deliveryDropoffId)?.friendsOrders ?? []
            }
            avatarId={avatarId}
            firstName={firstName}
            lastName={lastName}
            creditsEarnedSectionShown={showCreditsEarnedSection}
          />
        )}
      </Box>
    </SpinnerCard>
  )
}

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: 'black',
    fontWeight: 400,
    padding: '8px',
    '& p, & a': {
      color: '#fff !important',
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
}))

const CreditsEarned = ({ creditsEarnedInCents, deliveryFeePerPerson, deliveryFeeContribution }) => {
  const classes = useStyles()
  return (
    <Box marginBottom={'2em'}>
      <Box marginBottom={'2em'}>
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus2, fontWeight: 500 }}>
          Summary of Orders & Credits Earned
        </Typography>
      </Box>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus5, fontWeight: 700 }}>
          {formatCentsToPrettyDollars(creditsEarnedInCents)}
        </Typography>
        <Box display={'flex'} alignItems={'center'}>
          <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus2, fontWeight: 500 }}>
            Credits Earned
          </Typography>
          <Tooltip
            interactive
            disableFocusListener
            disableTouchListener
            title={
              <CreditsEarnedNotice
                deliveryFeePerPerson={deliveryFeePerPerson}
                deliveryFeeContribution={deliveryFeeContribution}
              />
            }
            classes={{ tooltip: classes.customTooltip }}
          >
            <InfoIcon
              fontSize="small"
              style={{
                color: 'ABADB2',
                marginLeft: '3px',
                marginBottom: '4px',
                transform: 'scale(0.8)',
              }}
            />
          </Tooltip>
        </Box>
      </Box>
    </Box>
  )
}

const CustomersOrdered = ({
  friendsOrders,
  avatarId,
  firstName,
  lastName,
  creditsEarnedSectionShown,
}) => {
  const userFullName = `${firstName} ${lastName} (You)`
  const friendImageUrlBase = process.env.REACT_APP_IMAGE_LAMBDA
  const customersOutsideOffice = []
  const friendsInsideOffice = []

  if (!isEmpty(friendsOrders)) {
    for (const friendOrder of friendsOrders) {
      const friend = friendOrder.friend
      if (friend.email === '') {
        customersOutsideOffice.push(friend)
      } else {
        friendsInsideOffice.push(friend)
      }
    }
  }
  return (
    <Box>
      <Box marginBottom={'1em'}>
        <Typography
          style={{
            fontSize: themeConWeb.fontSizes.basePlus2,
            fontWeight: creditsEarnedSectionShown ? null : 500,
          }}
        >
          Customers who&apos;ve ordered {`(${friendsOrders.length + 1})`}
        </Typography>
      </Box>
      <Box
        height={creditsEarnedSectionShown ? '11em' : '23em'}
        maxHeight={creditsEarnedSectionShown ? '11em' : '23em'}
        style={{
          overflowY: 'auto',
          width: '100%',
        }}
      >
        <Customer name={userFullName} friendImageUrlBase={friendImageUrlBase} avatarId={avatarId} />
        {!isEmpty(friendsInsideOffice) &&
          friendsInsideOffice.map(friend => {
            const name = `${friend.firstName} ${friend.lastName}`
            return (
              <Customer
                key={friend.userId}
                avatarId={friend.avatarId}
                name={name}
                friendImageUrlBase={friendImageUrlBase}
              />
            )
          })}
        {!isEmpty(customersOutsideOffice) &&
          customersOutsideOffice.map((_, index) => {
            return (
              <Customer
                key={index}
                name={'Foodsby Customer'}
                friendImageUrlBase={friendImageUrlBase}
                avatarId={null}
              />
            )
          })}
      </Box>
    </Box>
  )
}

const Customer = ({ name, avatarId, friendImageUrlBase }) => {
  return (
    <Box display={'flex'} flexDirection={'row'} marginBottom={'0.5em'}>
      <Avatar
        alt={name}
        src={
          avatarId && encodeURI(`${friendImageUrlBase}/profiles/${avatarId}.jpg?height=50&width=50`)
        }
        variant="circular"
        style={{ width: '30px', height: '30px' }}
      />
      <Box marginLeft={'0.5em'} marginTop={'0.2em'}>
        <Typography style={{ fontSize: themeConWeb.fontSizes.basePlus1, fontWeight: 500 }}>
          {name}
        </Typography>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state, entryProps) => {
  const { loading, order, orders } = state.orderDetail
  const { profile, updatingModal } = state.profile
  const { isLoadingFavorites } = state.favorite
  const { favoriteInfo } = state.checkout
  const { submitting } = state.ticket
  const { reasons } = state
  const { isWebpSupported } = state.browser
  const {
    isUpdatingSavedLocation,
    showDeliveryInstructionsDialog,
    updateSavedLocationError,
  } = state.location
  const deliveryLocationId = entryProps.match.params.locationId
  const curSavedLocation = selectCurrentSavedLocation(
    set(state, 'location.location.deliveryLocationId', deliveryLocationId),
  )
  const location = selectCurrentLocationWithAddress(state)
  const { friendsOrdered, isLoadingFriendsOrders } = state.friends
  const offices = selectOfficeAccounts(state)
  const { selectedDate, deliveryDropoff } = state.delivery
  const {
    profile: { avatarId, firstName, lastName },
  } = state.profile

  return {
    curSavedLocation,
    location,
    friendsOrdered,
    isLoadingFriendsOrders,
    avatarId,
    firstName,
    lastName,
    offices,
    selectedDate,
    deliveryDropoff,
    favoriteInfo,
    isLoadingFavorites,
    isUpdatingSavedLocation,
    isWebpSupported,
    loading,
    order,
    orders,
    profile,
    reasons,
    showDeliveryInstructionsDialog,
    submitting,
    updateSavedLocationError,
    updatingModal,
  }
}

const mapDispatchToProps = {
  closeAutoFavorite,
  loadDeliveryDropoffStart,
  loadFavoriteStart,
  loadMenuStart,
  loadOrderByIdStart,
  loadOrderStart,
  loadOfficesStart,
  getFriendsOrdersStart,
  loadReasonsByOrder,
  submitTicket,
  toggleDeliveryInstructionsDialog,
  updateUserSavedLocationStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageConfirmation)
